import type { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const heroCarouselData: PageData = [
  {
    formId: 'formGroup1',
    heading: 'Slide',
    data: [
      { id: 'tagline', label: 'Tagline (1 line)', type: 'input' },
      { id: 'title', label: 'Title (max 4 lines)', type: 'textarea' },
      { id: 'description', label: 'Description (max 2 lines)', type: 'textarea' },
      { id: 'buttonText', label: 'Button text (leave empty to hide)', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      {
        id: 'image',
        label: 'Slide image',
        info: getIdealImageSize(616, 345),
        type: 'image'
      },
      { id: 'bgColor1', label: 'Background color 1 (e.g. #FC3E46)', type: 'input' },
      { id: 'bgColor2', label: 'Background color 2 (e.g. #ED1B24)', type: 'input' },
      {
        id: 'textColor',
        label: 'Text color',
        type: 'dropdown',
        options: [
          { label: 'Select a Text Colour', value: '' },
          { label: 'Black (#000)', value: '#000000' },
          { label: 'White (#FFF)', value: '#FFFFFF' }
        ]
      }
    ]
  }
];

export const introData: PageData = [
  {
    formId: 'form1',
    heading: 'Intro Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'introTitle', label: 'Intro title', type: 'input' },
      { id: 'introSubtitle1', label: 'Intro subtitle (first part)', type: 'input' },
      { id: 'introSubtitle2', label: 'Intro subtitle (middle part in bold)', type: 'input' },
      { id: 'introSubtitle3', label: 'Intro subtitle (last part)', type: 'input' },
      { id: 'introContent', label: 'Intro content', type: 'textarea' },
      {
        id: 'introBannerImage',
        label: 'Intro banner image',
        info: getIdealImageSize(335, 261),
        type: 'image'
      },
      { id: 'introButtonText', label: 'Intro button text', type: 'input' },
      { id: 'introButtonLink', label: 'Intro button link', type: 'input' },
      {
        id: 'mapLocationImage1',
        label: 'Map background location image (desktop)',
        info: getIdealImageSize(762, 278),
        type: 'image'
      },
      {
        id: 'mapLocationImage2',
        label: 'Map background location image (mobile)',
        info: getIdealImageSize(343, 578),
        type: 'image'
      },
      {
        id: 'mapImage',
        label: 'Image inside the map',
        info: getIdealImageSize(160, 80),
        type: 'image'
      },
      { id: 'mapPlace', label: 'Name of the place inside the map', type: 'input' },
      { id: 'mapAddress', label: 'Address of the place inside the map', type: 'input' },
      { id: 'mapCategory', label: 'Category of the place inside the map', type: 'input' },
      { id: 'mapPresentedText', label: 'Map presented by text', type: 'input' },
      {
        id: 'mapPresentedImage',
        label: 'Map presented by image',
        info: getIdealImageSize(77, 77),
        type: 'image'
      },
      { id: 'mapTitle', label: 'Map title', type: 'input' },
      { id: 'mapSubtitle', label: 'Map subtitle', type: 'input' },
      { id: 'mapLinkText1', label: 'Map link 1 text', type: 'input' },
      { id: 'mapLinkUrl1', label: 'Map link 1 URL', type: 'input' },
      { id: 'mapLinkText2', label: 'Map link 2 text', type: 'input' },
      { id: 'mapLinkUrl2', label: 'Map link 2 URL', type: 'input' },
      { id: 'newsTitle', label: 'News title', type: 'input' },
      { id: 'newsSubtitle', label: 'News subtitle', type: 'input' },
      { id: 'newsDetails', label: 'News more details text', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Intro Statistics',
    data: [
      { id: 'value', label: 'Stats value', type: 'input' },
      { id: 'content', label: 'Stats content', type: 'input' }
    ]
  }
];

export const partnersData: PageData = [
  {
    formId: 'form1',
    heading: 'Partners Section',
    data: [
      { id: 'title1', label: 'Major Partner Title', type: 'input' },
      { id: 'title2', label: 'Meet Our Partners Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'heading', label: 'Heading', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup3',
    heading: 'Major Partner Logo',
    data: [
      {
        id: 'logoMajor',
        label: 'Major Partner Logo',
        info: getIdealImageSize(83, 83),
        type: 'image'
      }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Other Partner Logo',
    data: [
      {
        id: 'logo',
        label: 'Partner Logo',
        info: getIdealImageSize(120, 'auto'),
        type: 'image'
      }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Partner Cards',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'icon', label: 'Icon', info: getIdealImageSize(48, 48), type: 'image' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(411, 546), type: 'image' },
      { id: 'color', label: 'Background colour', type: 'input' }
    ]
  }
];

export const aboutData: PageData = [
  {
    formId: 'form1',
    heading: 'About Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(1280, 665), type: 'image' },
      { id: 'partnerTitle', label: 'Founding partners title', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Partner Logos (desktop)',
    data: [
      {
        id: 'logoDesktop',
        label: 'Partner Logo (desktop)',
        info: getIdealImageSize('auto', 48),
        backgroundColor: '#000',
        type: 'image'
      }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Partner Logos (mobile)',
    data: [
      {
        id: 'logoMobile',
        label: 'Partner Logo (mobile)',
        info: getIdealImageSize('auto', 48),
        type: 'image'
      }
    ]
  }
];

export const clientData: PageData = [
  {
    formId: 'form1',
    heading: 'Client Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'imageText', label: 'Text inside image', type: 'input' },
      {
        id: 'imageLogo',
        label: 'Logo inside image',
        type: 'image',
        backgroundColor: '#ef2d49ba',
        info: getIdealImageSize(149, 40)
      }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Client Details',
    data: [
      { id: 'clientTestimony', label: 'Client Testimony', type: 'textarea' },
      { id: 'clientName', label: 'Client Name', type: 'textarea' },
      {
        id: 'companyLogo',
        label: 'Company Logo',
        info: getIdealImageSize(24, 24),
        type: 'image'
      },
      { id: 'companyName', label: 'Company Name', type: 'textarea' },
      { id: 'clientImage', label: 'Client Image', info: getIdealImageSize(519, 560), type: 'image' }
    ]
  }
];

export const communityData: PageData = [
  {
    formId: 'form1',
    heading: 'Community Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      {
        id: 'image1',
        label: 'Banner Image (desktop)',
        info: getIdealImageSize(910, 574),
        type: 'image'
      },
      {
        id: 'image2',
        label: 'Banner Image (mobile)',
        info: getIdealImageSize(910, 574),
        type: 'image'
      }
    ]
  }
];

export const newsData: PageData = [
  {
    formId: 'form1',
    heading: 'News Section',
    data: [{ id: 'title', label: 'Title', type: 'input' }]
  }
];

export const reportData: PageData = [
  {
    formId: 'form1',
    heading: 'Report Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(567, 567), type: 'image' }
    ]
  }
];

export const faqData: PageData = [
  {
    formId: 'form1',
    heading: 'FAQ Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'FAQ: Questions and Answers',
    data: [
      { id: 'question', label: 'Question', type: 'textarea' },
      { id: 'answer', label: 'Answer', type: 'textarea' }
    ]
  }
];
